import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed } from 'vue'

interface IProps {
  modelValue: number
  size?: 'lg' | 'md' | 'sm'
  model?: 'horizontal' | 'vertical'
  minusIconBind?: Record<PropertyKey, unknown>
  plusIconBind?: Record<PropertyKey, unknown>
  minusClass?: string | (string | Record<string, boolean>)[] | Record<string, boolean>
  minusDisableClass?: string | (string | Record<string, boolean>)[] | Record<string, boolean>
  plusClass?: string | (string | Record<string, boolean>)[] | Record<string, boolean>
  plusDisableClass?: string | (string | Record<string, boolean>)[] | Record<string, boolean>
  min?: number
  max?: number
}

interface IEmits {
  (event: 'update:model-value', data: number): void
}


export default /*@__PURE__*/_defineComponent({
  ...{ name: 'KCounter' },
  __name: 'KCounter',
  props: {
    modelValue: {},
    size: { default: 'md' },
    model: {},
    minusIconBind: { default: () => ({}) },
    plusIconBind: { default: () => ({}) },
    minusClass: { default: 'bg-dark-bg-20' },
    minusDisableClass: { default: 'bg-cool-gray-50 cursor-not-allowed' },
    plusClass: { default: 'bg-dark-bg-20' },
    plusDisableClass: { default: 'bg-cool-gray-50 cursor-not-allowed' },
    min: { default: 0 },
    max: { default: Infinity }
  },
  emits: ["update:model-value"],
  setup(__props: any, { emit: __emit }) {



const props = __props

const iconSize = computed(() => {
  if (props.size === 'lg') return '24px'
  else if (props.size === 'md') return '20px'
  return '16px'
})

const emit = __emit

const checkDigits = (event: KeyboardEvent) => {
  const enteredNumber = Number(event.key)
  if ([46, 8, 9, 27, 189].includes(event.keyCode)) {
    return
  }
  const regex = /^\d+$/
  if (!regex.test(event.key) || enteredNumber < props.min || enteredNumber > props.max) {
    event.preventDefault()
  }
}

const updateModelValue = (event: any) => {
  // FIXME: fix event type
  const newValue = event.target.innerText.replace(/[^\d]/g, '')
  if (!isNaN(newValue) && newValue > 0) emit('update:model-value', Number(newValue))

  setTimeout(() => {
    const range = document.createRange()
    const selection = window.getSelection()
    range.setStart(event.target.childNodes[0], event.target.innerText?.length)
    range.collapse(true)
    selection?.removeAllRanges()
    selection?.addRange(range)
  })
}

return (_ctx: any,_cache: any) => {
  const _component_KIcon = _resolveComponent("KIcon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["k-counter rounded-32 q-pa-xs bg-white flex inline items-center justify-center", [`k-counter__${__props.model}--${__props.size}`, __props.model === 'horizontal' ? 'gap-xs' : 'column reverse gap-sm']])
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["cursor-pointer flex rounded-circle transition", [__props.size !== 'lg' ? 'q-pa-xs' : 'q-pa-sm', __props.modelValue > __props.min ? __props.minusClass : __props.minusDisableClass]]),
      onClick: _cache[0] || (_cache[0] = ($event: any) => (__props.modelValue > __props.min && _ctx.$emit('update:model-value', __props.modelValue - 1)))
    }, [
      _createVNode(_component_KIcon, _mergeProps({
        name: "minus",
        size: iconSize.value,
        color: "white"
      }, __props.minusIconBind), null, 16, ["size"])
    ], 2),
    _createElementVNode("span", {
      class: _normalizeClass(["k-counter__input fw-500 text-cool-gray-100 flex-1 text-center flex items-center justify-center non-selectable", [__props.size !== 'lg' ? 'fs-15px' : 'fs-17px']]),
      contenteditable: "true",
      onKeydown: checkDigits,
      onInput: updateModelValue
    }, _toDisplayString(__props.modelValue), 35),
    _createElementVNode("div", {
      class: _normalizeClass(["cursor-pointer flex rounded-circle", [__props.size !== 'lg' ? 'q-pa-xs' : 'q-pa-sm', __props.modelValue < __props.max ? __props.plusClass : __props.plusDisableClass]]),
      onClick: _cache[1] || (_cache[1] = ($event: any) => (__props.modelValue < __props.max && _ctx.$emit('update:model-value', __props.modelValue + 1)))
    }, [
      _createVNode(_component_KIcon, _mergeProps({
        name: "plus",
        size: iconSize.value,
        color: "white"
      }, __props.plusIconBind), null, 16, ["size"])
    ], 2)
  ], 2))
}
}

})